import React, { useEffect, useState } from "react";
import { Button, Input, Textarea } from "@material-tailwind/react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import http from "../../../../services/http-common";

function EditLegalWebMetaData(props) {
  const { open, toogleOpenEditor, id } = props;
  const [scrapedContent, setScrapedContent] = useState(null);
  const [loading, setLoading] = useState(false);

  const errorFunc = (error) => {
    let message = error.response.data.message;
    toast.error(message);
  };

  const saveContent = useMutation(
    (id) => {
      return http.put(
        `law-website/update`,
        { id: id, ...scrapedContent },
        null
      );
    },
    {
      onSuccess: ({ data }) => {
        toast.success(data.message);
        toogleOpen();
      },
      onError: (error) => {
        errorFunc(error);
      },
      onMutate: () => {
        setLoading(true);
      },
      onSettled: () => {
        setLoading(false);
      },
    }
  );

  const toogleOpen = () => {
    if (loading) return false;
    if (open) {
      setScrapedContent("");
    }
    toogleOpenEditor();
  };

  const onChangeContent = (e) => {
    if (loading) return false;
    setScrapedContent({
      ...scrapedContent,
      metadata: {
        ...scrapedContent.metadata,
        [e.target.name]: e.target.value,
      },
    });
  };

  const onSubmit = () => {
    saveContent.mutate(id);
  };

  const getWebDetails = useMutation(
    (webId) => {
      return http.post(`law-website/findById`, { id: webId });
    },
    {
      onSuccess: ({ data }) => {
        setScrapedContent(data.website);
      },
      onError: (error) => {
        errorFunc(error);
      },
      onSettled: () => {
        setLoading(false);
      },
      onMutate: () => {
        setLoading(true);
      },
    }
  );

  const getWebDetailFunc = () => {
    if (id === null) return false;
    getWebDetails.mutate(id);
  };

  useEffect(() => {
    getWebDetailFunc();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={"sm"}
      onClose={toogleOpen}
      scroll={"paper"}
      animate={{
        mount: { scale: 1, y: 0 },
        unmount: { scale: 0.9, y: -100 },
      }}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
    >
      <DialogTitle id="scroll-dialog-title">Edit Website MetaData</DialogTitle>
      <DialogContent dividers={true}>
        {scrapedContent ? (
          <div className="p-4">
            <div className="mb-4">
              <span className="font-bold">Website: </span>
              {scrapedContent?.url}
            </div>
            <form className="space-y-4">
              <div>
                <label
                  htmlFor="document_title"
                  className="block text-sm font-medium"
                >
                  Document Title
                </label>
                <Input
                  type="text"
                  name="document_title"
                  value={scrapedContent?.metadata.document_title}
                  onChange={onChangeContent}
                />
              </div>
              <div>
                <label
                  htmlFor="filing_date"
                  className="block text-sm font-medium"
                >
                  Filing Date
                </label>
                <Input
                  type="text"
                  name="filing_date"
                  value={scrapedContent?.metadata.filing_date}
                  onChange={onChangeContent}
                />
              </div>
              <div>
                <label
                  htmlFor="jurisdiction"
                  className="block text-sm font-medium"
                >
                  Jurisdiction
                </label>
                <Input
                  type="text"
                  name="jurisdiction"
                  value={scrapedContent?.metadata.jurisdiction}
                  onChange={onChangeContent}
                />
              </div>
              <div>
                <label
                  htmlFor="document_type"
                  className="block text-sm font-medium"
                >
                  Document Type
                </label>
                <Input
                  type="text"
                  name="document_type"
                  value={scrapedContent?.metadata.document_type}
                  onChange={onChangeContent}
                />
              </div>
              <div>
                <label
                  htmlFor="decision_date"
                  className="block text-sm font-medium"
                >
                  Decision Date
                </label>
                <Input
                  type="text"
                  name="decision_date"
                  value={scrapedContent?.metadata.decision_date}
                  onChange={onChangeContent}
                />
              </div>
              <div>
                <label
                  htmlFor="parties_involved"
                  className="block text-sm font-medium"
                >
                  Parties Involved
                </label>
                <Input
                  type="text"
                  name="parties_involved"
                  value={scrapedContent?.metadata.parties_involved}
                  onChange={onChangeContent}
                />
              </div>
              <div>
                <label htmlFor="summary" className="block text-sm font-medium">
                  Summary
                </label>
                <Textarea
                  name="summary"
                  rows="3"
                  value={scrapedContent?.metadata.summary}
                  onChange={onChangeContent}
                />
              </div>
            </form>
          </div>
        ) : (
          "Loading..."
        )}
      </DialogContent>
      <DialogActions className="space-x-2">
        <Button
          variant="text"
          size="sm"
          color="gray"
          className="mr-1 rounded-md"
          onClick={toogleOpen}
          disabled={loading}
        >
          <span>Close</span>
        </Button>
        <Button
          size="sm"
          className="rounded-md !bg-[#7a6fbe]"
          onClick={onSubmit}
          disabled={loading}
        >
          <span>Update</span>
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default EditLegalWebMetaData;
